(function($){
    $(function(){
    
        $('.zn-roi-calc').each(function(){
            function calcROI(){
                var 
                $roiCalc = $(".zn-roi-calc"),
                enteredV = {
                    "numberOfEmployees": Number($(".numberOfEmployees .enteredValue").val()),
                    "numberOfOpenPositions":  Number($(".numberOfOpenPositions .enteredValue").val()),
                    "hourlyWage":  Number($(".hourlyWage .enteredValue").val()),
                    "hrsPerWeek":  Number($(".hrsPerWeek .enteredValue").val()),
                    "timeToIndependence":  Number($(".timeToIndependence .enteredValue").val()),
                };
                definedV = {
                    "workWeeksInYr": Number($roiCalc.attr("data-workWeeksInYr")),
                    "weeksInYr": Number($roiCalc.attr("data-weeksInYr")),
                    "weeksInMonth": Number($roiCalc.attr("data-weeksInMonth")),
                    "additionalEmployeeCost": Number($roiCalc.attr("data-additionalEmployeeCost"))/100, //percent 
                    "retentionRate": Number($roiCalc.attr("data-retentionRate"))/100, //percent 
                    "newHireCost": Number($roiCalc.attr("data-newHireCost"))/100, //percent 
                    "proficencybeforeIndependence": Number($roiCalc.attr("data-proficencybeforeIndependence"))/100, //percent 
                    "acadiaEfficiency": Number($roiCalc.attr("data-acadiaEfficiency"))/100, //percent
                    "acadiaRetention": Number($roiCalc.attr("data-acadiaRetention"))/100, //percent
                    "acadiaTTP": Number($roiCalc.attr("data-acadiaTTP"))/100, //percent
                };
                calculatedV = {
                    "hrsPerYear": enteredV.numberOfEmployees*enteredV.hrsPerWeek*definedV.workWeeksInYr,
                    "avgEmployeeCost": enteredV.hourlyWage*enteredV.hrsPerWeek*definedV.weeksInYr*(1+definedV.additionalEmployeeCost)
                }
                calculatedV.workforceComp = calculatedV.avgEmployeeCost*(enteredV.numberOfEmployees+enteredV.numberOfOpenPositions);
                calculatedV.retentionRate = definedV.retentionRate*100;
                calculatedV.turnoverEmployees = Math.round((enteredV.numberOfEmployees+enteredV.numberOfOpenPositions)*(1-definedV.retentionRate));
                calculatedV.newHireCost = calculatedV.avgEmployeeCost*definedV.newHireCost;
                calculatedV.turnoverCost = calculatedV.turnoverEmployees*calculatedV.newHireCost;
                calculatedV.newHireTTP = enteredV.timeToIndependence*(definedV.weeksInMonth*enteredV.hrsPerWeek);
                calculatedV.totalNewHireTTP = calculatedV.newHireTTP*enteredV.numberOfOpenPositions;
                calculatedV.totalNewHireTTPCost = (enteredV.hourlyWage*calculatedV.totalNewHireTTP)*(1-definedV.proficencybeforeIndependence);
                calculatedV.workforceInvestment = calculatedV.totalNewHireTTPCost+calculatedV.turnoverCost+calculatedV.workforceComp;
                calculatedV.employeeEfficiency = definedV.acadiaEfficiency*calculatedV.hrsPerYear;
                calculatedV.employeeEfficiencySavings = calculatedV.employeeEfficiency*enteredV.hourlyWage;
                calculatedV.employeeRentention = enteredV.numberOfOpenPositions*definedV.acadiaRetention;
                calculatedV.employeeRententionSavings = calculatedV.employeeRentention*calculatedV.newHireCost;
                calculatedV.employeeTTP = calculatedV.totalNewHireTTP-((calculatedV.newHireTTP*definedV.acadiaTTP)*enteredV.numberOfOpenPositions);
                calculatedV.employeeTTPSavings = (enteredV.hourlyWage*calculatedV.employeeTTP)*(1-definedV.proficencybeforeIndependence);
                calculatedV.laborSavings = calculatedV.employeeEfficiencySavings+calculatedV.employeeRententionSavings+calculatedV.employeeTTPSavings;
                

                for (var calculatedValue in calculatedV){
                    if (calculatedV.hasOwnProperty(calculatedValue)) {
                        if(calculatedValue == 'retentionRate'){
                            $('.'+calculatedValue+'.calcValue .roiValue').html(calculatedV[calculatedValue].toLocaleString("en", {   
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                            }));
                        }else{
                            $('.'+calculatedValue+'.calcValue .roiValue').html(calculatedV[calculatedValue].toLocaleString("en", {   
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }));
                        }
                    }
                }
            };

            calcROI();

            $(this).find('.rangeInput').each(function(){
                var $range = $(this).find('.rangeValue');
                var $field = $(this).find('.enteredValue');
                $range.on('change', function(){ 
                    if($field.val() != $range.val()){
                        $field.val($range.val());
                        calcROI();
                    }  
                });
                $field.on('keyup change', function(){ 
                    if($field.val() != $range.val()){
                        $range.val($field.val());
                        calcROI();
                    }  
                });
            });

        });
    
    
        $('.roi-info').modalDialog();
        
        $('.roi-current-set-toggle').on('click', function(){ 
            var $this = $(this);
            $($this).parents('.roi-current-set').find('.roi-current-subset').slideToggle('fast');
            $($this).toggleClass('open');
        });
        
    });

})($JQ);
